
import { useEffect, useState } from 'react';
import { /* useNavigate, */ useParams, useSearchParams } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';
import Landing from './Landing';
import { useIsMobile } from '@/hooks/use-mobile';
import MobileReferralView from '@/components/landing/MobileReferralView';
import { ReferralStorageService } from '@/services/referral/ReferralStorageService';
import { usePermissions } from '@/contexts/unified-permissions';

const ReferralLanding = () => {
  const { referralCode } = useParams();
  const [searchParams] = useSearchParams();
  const campaign = searchParams.get('campaign');

  const { toast } = useToast();
  const [isProcessing, setIsProcessing] = useState(true);
  const [visitorId, setVisitorId] = useState<string>('');
  const { authReady } = usePermissions();
  
  // Use the useIsMobile hook instead of isMobileWeb() function
  const isMobile = useIsMobile();

  useEffect(() => {
    // Set the referral code in storage to be used during signup
    const storeAndTrackReferral = async () => {
      // Wait for auth to be ready before processing referrals
      if (!authReady) {

        return;
      }
      
      if (referralCode) {
        try {
          // Get or create visitor ID for tracking
          const visitorId = ReferralStorageService.getOrCreateVisitorId();
          setVisitorId(visitorId);
          
          // Store referral code with proper persistence
          ReferralStorageService.storeReferralCode(referralCode, campaign || undefined);

          
          // Record referral link visit in database with visitor tracking (only when online)
          if (navigator.onLine) {
            try {
              // Call the RPC function with type-safe parameters
              await supabase.rpc('record_referral_visit', {
                code: referralCode,
                visitor_id: visitorId,
                campaign_source: campaign || null,
                user_agent: navigator.userAgent || null
              });

            } catch (error) {
              console.error('Error recording referral visit:', error);
              // Non-critical error, don't block UI
            }
          } else {
            // Offline mode - referral will be recorded when online
          }
          
          // Show toast notification
          toast({
            title: "Referral applied",
            description: "You'll receive 30% off when you sign up!",
          });
        } catch (error) {
          console.error('Error storing referral code:', error);
        }
      } else {
        // Check if there's a stored referral code even if none in URL
        const storedCode = ReferralStorageService.getStoredReferralCode();
        if (storedCode) {
          // Previously stored referral code found
        }
      }
      setIsProcessing(false);
    };
    
    if (authReady) {
      storeAndTrackReferral();
    }
  }, [referralCode, campaign, toast, authReady]);

  // Show mobile version for mobile devices
  if (isMobile) {
    return (
      <MobileReferralView 
        referralCode={referralCode} 
        isProcessing={isProcessing} 
        visitorId={visitorId}
        campaign={campaign}
      />
    );
  }

  // Show standard landing page with referral info for desktop
  return (
    <Landing isReferral={true} referralCode={referralCode} />
  );
};

export default ReferralLanding;
